import {
  PrimaryButton,
  ReactSelect,
  ReactSelectProps,
  SecondaryButton,
  TextField,
} from "@graffer-inc/console-design-kit";

type Props = {
  disabledSubmitButton: boolean;
  inputBusinessIssuerName: string;
  inputBusinessIssuerNameError: string;
  inputBusinessIssuerRegistrationNumber: string;
  inputBusinessIssuerRegistrationNumberError: string;
  inputBusinessIssuerGroups: ReactSelectProps<string>["value"];
  inputBusinessIssuerGroupsError: string;
  orgGroupSelectOptions: ReactSelectProps<string>["options"];
  handleOnSetRedirectToList: () => void;
  handleOnChangeBusinessIssuerName: (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  handleOnChangeBusinessIssuerRegistrationNumber: (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  handleOnChangeGroupSearchKeyword: (input: string) => void;
  handleOnChangeBusinessIssuerGroups: (
    value: ReactSelectProps<string>["value"],
  ) => void;
  handleOnSubmit: () => Promise<void>;
};

export const QualifiedInvoiceBusinessIssuersCreateForm: React.FC<Props> = ({
  disabledSubmitButton,
  inputBusinessIssuerName,
  inputBusinessIssuerNameError,
  inputBusinessIssuerRegistrationNumber,
  inputBusinessIssuerRegistrationNumberError,
  inputBusinessIssuerGroups,
  inputBusinessIssuerGroupsError,
  orgGroupSelectOptions,
  handleOnSetRedirectToList,
  handleOnChangeBusinessIssuerName,
  handleOnChangeBusinessIssuerRegistrationNumber,
  handleOnChangeGroupSearchKeyword,
  handleOnChangeBusinessIssuerGroups,
  handleOnSubmit,
}) => {
  return (
    <form>
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h1 className="title is-size-4">新規登録</h1>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <PrimaryButton
              text="登録する"
              type="button"
              disabled={disabledSubmitButton}
              onClick={handleOnSubmit}
            />
          </div>
          <div className="level-item">
            <SecondaryButton
              text="キャンセル"
              type="button"
              onClick={handleOnSetRedirectToList}
            />
          </div>
        </div>
      </div>
      <div className="field mb-4">
        <TextField
          required
          label="登録事業者名"
          description={"適格請求書発行事業者に登録した名称を入力してください。"}
          placeholder={"〇〇市"}
          value={inputBusinessIssuerName}
          errorMessages={inputBusinessIssuerNameError}
          onChange={(e) => {
            handleOnChangeBusinessIssuerName(e);
          }}
        />
      </div>
      <div className="field mb-4">
        <TextField
          required
          label="登録番号"
          description={"登録番号は13桁の半角数字で入力してください。"}
          placeholder={"1234567890123"}
          value={inputBusinessIssuerRegistrationNumber}
          prefixText={"T"}
          errorMessages={inputBusinessIssuerRegistrationNumberError}
          onChange={(e) => {
            handleOnChangeBusinessIssuerRegistrationNumber(e);
          }}
        />
      </div>
      <div className="field">
        <ReactSelect
          isClearable
          isMulti
          label={"インボイスを交付可能なグループ"}
          description={
            "登録事業者名・登録番号を参照して、インボイスを交付することが可能なグループを設定します。"
          }
          placeholder={"選択またはキーワードで検索"}
          required={false}
          value={inputBusinessIssuerGroups}
          options={orgGroupSelectOptions}
          noOptionsMessage={() => "グループがありません"}
          errorMessages={inputBusinessIssuerGroupsError}
          onInputChange={handleOnChangeGroupSearchKeyword}
          onChange={handleOnChangeBusinessIssuerGroups}
        />
      </div>
    </form>
  );
};
